exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@keyframes button-hover{0%{transform:perspective(100px) rotateX(-20deg) translateY(10px) translateZ(20px)}to{transform:perspective(100px) rotateX(20deg) translateY(10px) translateZ(20px)}}.nextButton{font-family:Fjalla One,sans-serif;font-size:32px;color:#fff;width:80px;position:absolute;bottom:32px;right:32px;z-index:3;text-align:center;user-select:none;transition-timing-function:cubic-bezier(0,0,1,2.19);background:#fff;background:linear-gradient(0deg,#000 0,#efefef);box-shadow:0 0 10px rgba(0,0,0,.14);animation-name:button-hover;animation-iteration-count:infinite;animation-duration:1s;border-radius:10px}.nextButton:hover{cursor:pointer;background:hsla(0,0%,100%,.1)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/NextButton/styles.sass
// module id = 119
// module chunks = 0